import { render, staticRenderFns } from "./MailDeactivation.vue?vue&type=template&id=475b8737"
import script from "./MailDeactivation.vue?vue&type=script&lang=ts"
export * from "./MailDeactivation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports